import {
    FETCH_DOMAINS_REQUEST,
    FETCH_DOMAINS_SUCCESS,
    FETCH_DOMAINS_FAILURE,
} from './types/domains-action-types';

import MimirService from '../services/mimir-service';

function fetchDomainsRequest(){
    return {
        type: FETCH_DOMAINS_REQUEST
    };
}
function fetchDomainsSuccess( { domainsById, allIds } ){
    return {
        allIds,
        domainsById,
        type: FETCH_DOMAINS_SUCCESS,
    };
}
function fetchDomainsFailure( error ){
    return {
        error,
        type: FETCH_DOMAINS_FAILURE,
    };
}

export function fetchDomains(){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchDomainsRequest() );
        const api = new MimirService( DATA_API );

        return api.getApprovedDomains().then(
            ( response ) => dispatch( fetchDomainsSuccess( response ) ),
            ( error ) => dispatch( fetchDomainsFailure( error ) )
        );
    };
}
